(function($) {
  var amenities = $('.amenities');
  var links = amenities.find('li');
  var images = amenities.find('a');
  var arrows = amenities.find('.amenities__arrows');

  // Attach Link hover event
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    link.addEventListener('mouseover', function(e) {
      onLinkHover(link, i);
    })
  }

  function onLinkHover (link, index) {
    $(links).removeClass('active');
    $(link).addClass('active');
    $(images).removeClass('active');
    $(images).filter('[data-group='+(index + 1)+']').first().addClass('active');
  }

  // Allow images from the same group to be changed by arrows
  arrows.on('click', 'button', function() {
    var dir = $(this).data('dir');
    var activeImage = $(images).filter('[class=active]');
    var groupSelector = '[data-group=' + activeImage.data('group') + ']'
    var group = $(images).filter(groupSelector);
    var activeIndex = activeImage.index(groupSelector);

    if (group.length > 1) {
      var index = 0;

      if (dir === 'prev') {
        index = activeIndex === 0 ? group.length - 1 : activeIndex - 1;
      } else {
        index = activeIndex === group.length - 1 ? 0 : activeIndex + 1;
      }

      activeImage.removeClass('active');
      group.eq(index).addClass('active');
    }
  });

  // Lightbox functionality
  $('.amenities .hero__img').magnificPopup({
    delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
    callbacks: {
      buildControls: function() {
        // Append arrow controls to the title container
        var wrap = this.contentContainer.find('.mfp-title-wrap');
        wrap.prepend(this.arrowLeft);
        wrap.append(this.arrowRight);
      },
      open: function() {
        bodyScrollLock.disableBodyScroll(this.contentContainer);
      },
      close: function() {
        bodyScrollLock.enableBodyScroll(this.contentContainer);
      }
    },
		image: {
      markup: '<div class="mfp-figure">'+
                '<div class="mfp-close"></div>'+
                '<div class="mfp-img-wrap">'+
                  '<div class="mfp-bottom-bar">'+
                    '<div class="mfp-title-wrap">'+
                      '<div class="mfp-title"></div>'+
                    '</div>'+
                    '<div class="mfp-counter"></div>'+
                  '</div>'+
                  '<div class="mfp-img"></div>'+
                '</div>'+
              '</div>',
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			titleSrc: function(item) {
				return item.el.attr('title');
			}
		}
	});
})(jQuery);
